<template>
  <div>
    <div class="d-flex flex-row justify-content-around"
      style="padding-top: 0%; position: relative; overflow: hidden; display: flex; justify-content: center; align-items: center; height: 600px">
      <div :id="chartId"
        style="top: 0; height: 100%; width: 90%; max-height: 500px; max-width:750px; position: absolute;"></div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */

import * as am4core from "@amcharts/amcharts4/core"
import * as am4charts from "@amcharts/amcharts4/charts"
import { ref, defineProps, onMounted, watch } from "vue";
import api from '@/services/api'
import { countryToAlpha3 } from "country-to-iso";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  data_indicator: {
    type: String,
    required: false,
  },
  data_indicator_region: {
    type: String,
    required: false,
  },
  chartData: {
    type: Object,
    required: true,
  },
  showCountry: {
    type: String,
    required: false,
  }
});

async function getCountry() {
  try {
    const response = await api.get(`/countries/${countryToAlpha3(props.showCountry)}?sorttype=country_name&cnttype=REG`);
    const countryData = response.data;
    // Assuming response.data.data is an array and region_id exists in each item
    regionId.value = countryData?.data?.[0]?.region_id || null;
    regionName.value = countryData?.data?.[0]?.region_name || null;

  } catch (error) {
    console.error('Erreur lors de la récupération des pays :', error);
  }
  console.log('props.showCountry:', countryToAlpha3(props.showCountry));
}

const chartId = ref(props.id);
const hasData = ref(false);
let highlightOperationCountry = true;
const data = ref([])
const regionId = ref(null);
const regionName = ref(null);

const createChart = () => {
  console.log("data_indicator", props.data_indicator)
  let chart = am4core.create(props.id, am4charts.XYChart)

  let title = chart.titles.create();
  title.text = "Country versus Region Comparison";
  title.fontSize = 20;
  title.marginBottom = 20;
  title.paddingRight = 80;
  title.align = "center";


  chart.exporting.menu = new am4core.ExportMenu();
  chart.exporting.filePrefix = 'CntVsRegionComparison'
  chart.exporting.menu.align = "left";
  // chart.exporting.filePrefix = this.$route.params.element + this.currentChartField + "Map";
  chart.exporting.menu.verticalAlign = "top";

  // let selectedCountrysRegion = ""
  // console.log("props.data_indicator_region",props.data_indicator_region)
  // for(let i = 0; i < props.chartData.length; i++){
  //   if(props.showCountry == props.chartData[i].country_name){
  //     selectedCountrysRegion = props.chartData[i].region_name
  //   }
  // }
  // console.log("selectedCountrysRegion",selectedCountrysRegion)
  let xAxis = chart.xAxes.push(new am4charts.ValueAxis());
  xAxis.title.text = props.showCountry;
  xAxis.min = 1;
  xAxis.max = 5;
  xAxis.strictMinMax = true;
  xAxis.renderer.labels.template.adapter.add("text", function (text, target) {
    let value = parseFloat(text);
    if (Number.isInteger(value)) {
      return value.toFixed(1);
    }
    return "";
  });

  let yAxis = chart.yAxes.push(new am4charts.ValueAxis());
  yAxis.title.text = regionName.value;
  yAxis.min = 1;
  yAxis.max = 5;
  yAxis.strictMinMax = true;
  yAxis.renderer.labels.template.adapter.add("text", function (text, target) {
    let value = parseFloat(text);
    if (Number.isInteger(value)) {
      return value.toFixed(1);
    }
    return "";
  });

  xAxis.renderer.grid.template.disabled = true;
  yAxis.renderer.grid.template.disabled = true;
  xAxis.renderer.minGridDistance = 20
  yAxis.renderer.minGridDistance = 20
  xAxis.renderer.line.strokeOpacity = 1
  yAxis.renderer.line.strokeOpacity = 1

  let series = chart.series.push(new am4charts.LineSeries());
  series.dataFields.valueX = "valCountry";
  series.dataFields.valueY = "valRegion";
  series.strokeOpacity = 0;
  series.fillOpacity = 0;



  let bullet = series.bullets.push(new am4charts.CircleBullet());
  // bullet.tooltipText = "AEIOU";
  bullet.circle.radius = 6;
  bullet.propertyFields.fill = "color";
  bullet.propertyFields.stroke = "color";


  let labelBullet = series.bullets.push(new am4charts.LabelBullet());
  labelBullet.label.fill = am4core.color("#000");
  labelBullet.label.fontSize = 12;
  labelBullet.label.dx = 10;

  bullet.tooltipText = "{indicator}";

  chart.cursor = new am4charts.XYCursor();
  chart.cursor.lineX.disabled = true;
  chart.cursor.lineY.disabled = true;
  chart.cursor.behavior = "zoomXY"

  // Activer les tooltips si ce n’est pas déjà fait
  xAxis.tooltip = new am4core.Tooltip();
  yAxis.tooltip = new am4core.Tooltip();

  // Formater les labels de l'info-bulle (tooltip) sur X
  xAxis.tooltip.label.adapter.add("text", function (text) {
    let value = parseFloat(text);
    return value.toFixed(1); // ou + " unité" si besoin
  });

  // Formater les labels de l'info-bulle (tooltip) sur Y
  yAxis.tooltip.label.adapter.add("text", function (text) {
    let value = parseFloat(text);
    return value.toFixed(1);
  });

  xAxis.tooltip.background.fill = am4core.color("#000");
  xAxis.tooltip.background.stroke = am4core.color("#000"); // sans bordure visible
  xAxis.tooltip.label.fill = am4core.color("#fff"); // texte blanc
  yAxis.tooltip.background.fill = am4core.color("#000");
  yAxis.tooltip.background.stroke = am4core.color("#000");
  yAxis.tooltip.label.fill = am4core.color("#fff");

  let guideSeries = chart.series.push(new am4charts.LineSeries());
  guideSeries.data = [
    { valCountry: 1, valRegion: 1 },
    { valCountry: 5, valRegion: 5 }
  ];

  guideSeries.dataFields.valueX = "valCountry";
  guideSeries.dataFields.valueY = "valRegion";

  guideSeries.stroke = am4core.color("#000000"); // Black color
  guideSeries.strokeWidth = 2;
  guideSeries.strokeDasharray = "3,3"; // Dotted line
  guideSeries.tooltipText = ""; // No tooltip
  guideSeries.strokeOpacity = 0.5;

  // Optional: disable bullets and interactions
  guideSeries.bullets.clear();
  guideSeries.interpolationDuration = 0;
  guideSeries.defaultState.transitionDuration = 0;

  let legend = new am4charts.Legend();

  legend.position = "right";
  legend.align = "left";
  chart.legend = legend;
  legend.useDefaultMarker = true;
  legend.data = [
    {
      name: "Risk",
      fill: am4core.color("#cc0000"),
    },
    {
      name: "Opportunity",
      fill: am4core.color("#38761d"),
    }
  ];

  legend.itemContainers.template.clickable = false;
  legend.itemContainers.template.focusable = false;
  legend.itemContainers.template.cursorOverStyle = am4core.MouseCursorStyle.default;
  legend.itemContainers.template.events.disableType("hit");

  var marker = chart.legend.markers.template.children.getIndex(0);

  marker.cornerRadius(12, 12, 12, 12);

  data.value.forEach((dataItem) => {
    console.log(dataItem)
    if (dataItem.type === "risk") {
      dataItem.color = "#cc0000"
    } else {
      dataItem.color = "#38761d"
    }
  });

  console.log(data.value)

  let topLeftLabel = chart.plotContainer.createChild(am4core.Label);
  topLeftLabel.html = `<p style=\"color:red; margin: 0px; font-size: 12px\">Lower Risk for ${props.showCountry} compared to ${regionName.value}</p><p style=\"color:green; margin: 0px; font-size: 12px\">Lower Opportunity for ${props.showCountry} compared to ${regionName.value}</p>`;
  topLeftLabel.fill = am4core.color("#000000");
  // topLeftLabel.background = new am4core.RoundedRectangle();
  // topLeftLabel.background.fill = am4core.color("#28a745"); 
  topLeftLabel.padding(5, 10, 5, 10);
  topLeftLabel.align = "left";
  topLeftLabel.valign = "top";
  topLeftLabel.marginLeft = 10;
  topLeftLabel.marginTop = 10;

  let bottomRightLabel = chart.plotContainer.createChild(am4core.Label);
  bottomRightLabel.html = `
      <div style="text-align: right; color: red; margin: 0; font-size: 12px;">
        Higher Risk for ${props.showCountry} compared to ${regionName.value}
      </div>
      <div style="text-align: right; color: green; margin: 0; font-size: 12px;">
        Higher Opportunity for ${props.showCountry} compared to ${regionName.value}
      </div>
    `;

  bottomRightLabel.fill = am4core.color("#ffffff");
  bottomRightLabel.padding(5, 10, 5, 10);
  bottomRightLabel.align = "right";
  bottomRightLabel.valign = "bottom";
  bottomRightLabel.marginRight = 10;
  bottomRightLabel.marginBottom = 10;

  let bulletLabel = series.bullets.push(new am4charts.LabelBullet());
  bulletLabel.label.text = "{indicator}";
  bulletLabel.label.fill = am4core.color("#000");
  bulletLabel.label.horizontalCenter = "left";
  bulletLabel.label.verticalCenter = "middle";
  bulletLabel.label.dx = 10;
  bulletLabel.locationX = 1;


  chart.data = data.value;
}








function parseData() {
  console.log("parseing deita")
  console.log(props.data_indicator)
  console.log(props.data_indicator_region)
  console.log("parseingue deita oveure")
}

onMounted(async () => {
  await getCountry();
  // setTimeout(() => {
  parseData();
  data.value.push({
    indicator: 'Eco & Biz Risk',
    type: 'risk',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'pilier1').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'pilier1' && value.name == regionId.value).map((value) => value.value)[0]
  }, {
    indicator: 'Pol & Geo Risk',
    type: 'risk',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'pilier2').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'pilier2' && value.name == regionId.value).map((value) => value.value)[0]
  }, {
    indicator: 'Social & Societal Risk',
    type: 'risk',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'pilier3').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'pilier3' && value.name == regionId.value).map((value) => value.value)[0]
  }, {
    indicator: 'Environmental Risk',
    type: 'risk',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'pilier4').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'pilier4' && value.name == regionId.value).map((value) => value.value)[0]
  }, {
    indicator: 'Macroeconomic',
    type: 'opport',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'cat_macro').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'cat_macro' && value.name == regionId.value).map((value) => value.value)[0]
  }, {
    indicator: 'Waste',
    type: 'opport',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'cat_waste').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'cat_waste' && value.name == regionId.value).map((value) => value.value)[0]
  }, {
    indicator: 'Water',
    type: 'opport',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'cat_water').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'cat_water' && value.name == regionId.value).map((value) => value.value)[0]
  }, {
    indicator: 'Energy',
    type: 'opport',
    valCountry: props.data_indicator.filter((value) => value.symbol == 'cat_energy').map((value) => value.myvalue)[0],
    valRegion: props.data_indicator_region.filter((value) => value.symbol == 'cat_energy' && value.name == regionId.value).map((value) => value.value)[0]
  },
  )
  createChart();
  // }, 500);

});


</script>

<style scoped>
.no-data-message {
  font-size: 16px;
  text-align: center;
  color: #999;
  padding: 20px;
}
</style>